import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { MapPin, CheckCircle2, Phone, Mail } from 'lucide-react';
import DiscountBanner from '../components/DiscountBanner';
import ReviewBanner from '../components/ReviewBanner';

const ServiceAreaPage = () => {
  const coverageAreas = [
    "Walsall Town Centre",
    "Bloxwich",
    "Willenhall",
    "Darlaston",
    "Aldridge",
    "Brownhills",
    "Pelsall",
    "Rushall",
    "Streetly",
    "Pheasey",
    "Great Barr (Walsall side)",
    "And surrounding areas"
  ];

  return (
    <div className="service-area-page">
      {/* Discount Banner - Top */}
      <DiscountBanner size="large" />
      
      {/* Review Banner */}
      <ReviewBanner />
      
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Service Area Coverage</h1>
          <p className="page-subtitle">Professional cat sitting across Walsall and surrounding areas</p>
        </div>
      </section>

      {/* Main Service Area */}
      <section className="coverage-section">
        <div className="container">
          <div className="coverage-intro">
            <MapPin className="coverage-icon" />
            <h2 className="section-title">We Cover Walsall & Surrounding Areas</h2>
            <p className="coverage-description">
              Maid for Cats is proud to serve the local community across Walsall and nearby areas. As a local independent business, we're committed to providing reliable, professional in-home cat sitting to our neighbours.
            </p>
          </div>

          <Card className="coverage-card">
            <CardContent className="coverage-content">
              <h3>Areas We Serve Include:</h3>
              <div className="coverage-grid">
                {coverageAreas.map((area) => (
                  <div key={area} className="coverage-item">
                    <CheckCircle2 className="coverage-check" />
                    <span>{area}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Why Choose Local */}
      <section className="why-local-section">
        <div className="container">
          <h2 className="section-title">Why Choose a Local Cat Sitter?</h2>
          
          <div className="why-local-grid">
            <Card className="why-local-card">
              <CardContent className="why-local-content">
                <h3>Quick Response Times</h3>
                <p>Being local means we can respond quickly to your enquiries and reach your home promptly in case of any emergencies.</p>
              </CardContent>
            </Card>

            <Card className="why-local-card">
              <CardContent className="why-local-content">
                <h3>Familiar with the Area</h3>
                <p>We know Walsall inside out, including local vets, pet shops, and the best routes to your home.</p>
              </CardContent>
            </Card>

            <Card className="why-local-card">
              <CardContent className="why-local-content">
                <h3>Community Connection</h3>
                <p>As part of your local community, we're invested in building long-term relationships and delivering exceptional service.</p>
              </CardContent>
            </Card>

            <Card className="why-local-card">
              <CardContent className="why-local-content">
                <h3>Reliable & Consistent</h3>
                <p>No long travel distances means consistent visit times and the same familiar face caring for your cats every time.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Not Sure Section */}
      <section className="unsure-section">
        <div className="container">
          <Card className="unsure-card">
            <CardContent className="unsure-content">
              <h2>Not Sure If We Cover Your Area?</h2>
              <p>If your location isn't listed above, don't worry! We're always happy to discuss coverage in nearby areas.</p>
              <p>Please get in touch with your postcode and we'll let you know straight away if we can help.</p>
              
              <div className="unsure-contact-options">
                <a href="tel:07344414860" className="unsure-contact-item">
                  <Phone className="unsure-icon" />
                  <div>
                    <span className="unsure-label">Call us</span>
                    <span className="unsure-value">07344 414860</span>
                  </div>
                </a>

                <a href="mailto:Enquiries@maidforcats.co.uk" className="unsure-contact-item">
                  <Mail className="unsure-icon" />
                  <div>
                    <span className="unsure-label">Email us</span>
                    <span className="unsure-value">Enquiries@maidforcats.co.uk</span>
                  </div>
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Local SEO Content */}
      <section className="local-seo-section">
        <div className="container">
          <div className="local-seo-content">
            <h2>Professional Cat Sitting in Walsall</h2>
            <p>
              Looking for a reliable <strong>cat sitter in Walsall</strong>? Maid for Cats provides professional <strong>in-home cat sitting services</strong> throughout Walsall and the surrounding areas. Our <strong>pet sitting service</strong> keeps your cats comfortable and happy in their own home while you're away.
            </p>
            <p>
              Unlike traditional catteries, our <strong>home cat sitting service</strong> means your cats can stay in familiar surroundings, maintaining their normal routine without stress. We serve all areas of Walsall including Bloxwich, Willenhall, Aldridge, and Brownhills.
            </p>
            <p>
              As a local, independent <strong>Walsall cat sitting service</strong>, we're proud to offer personalised care with the same consistent sitter for every visit. Whether you need daily visits, twice-daily care, or our VIP extended visits, we're here to help.
            </p>
            <p>
              Our service also includes our <strong>Home Guardians</strong> feature, keeping your home secure and lived-in while you travel. It's the complete solution for <strong>cat care in Walsall</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="area-cta-section">
        <div className="container">
          <div className="cta-box">
            <h2>Ready to Book Your Walsall Cat Sitter?</h2>
            <p>Contact us today to arrange your free meet and greet.</p>
            <Link to="/contact">
              <Button size="lg" className="cta-button-large">
                Book Your Free Meet & Greet
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceAreaPage;
